import {FolderSection} from 'constants/FolderConstants';
import * as NavConstants from 'constants/NavConstants';
import {getSearchableRegistrySupportedOligoAwareTypes, RegistrySummary} from 'constants/RegistryConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import * as RegistryUtil from 'registry/RegistryUtil';
import {FilterKey, keyToEmptyFilter, Operator, SearchParams} from 'search/SearchConstants';
import * as SearchPreferences from 'search/SearchPreferences';
import isModelTypeEnabledForListing from 'util/isModelTypeEnabledForListing';

export function getDefaultRegistrySearchParams(registry: RegistrySummary): SearchParams {
  return {
    filters: [
      {
        ...keyToEmptyFilter(FilterKey.TYPES),
        value: getSearchableRegistrySupportedOligoAwareTypes().filter((type) =>
          isModelTypeEnabledForListing(type)
        ),
      },
      {
        ...keyToEmptyFilter(FilterKey.FOLDER),
        value: registry.rootFolder.api_identifier,
      },
      {
        ...keyToEmptyFilter(FilterKey.REGISTRY_COLLECTION_OWNER),
        value: RegistryUtil.getDefaultCollectionId(registry),
      },
      {key: FilterKey.FOLDER_SECTION, operator: Operator.IS, value: FolderSection.INVENTORY},
    ],
    limit: getSelectedPageSize(),
    offset: 0,
    query: '',
    sorts: SearchPreferences.getAppliedSortsFromUserPreference(NavConstants.Section.REGISTRIES),
  };
}
